import mountSSR from 'venuescanner-js/react/mountSSR'

mountSSR({
  'Srp': () => { return import('venuescanner-js/react/components/Srp') }
})
